import React from 'react';

import ProjectIdsEnum from '../settings/ProjectIdsEnum';
import Settings from '../settings';

import resourcesFramework from "./framework/resources";
import itResourcesFramework from "./framework/resources-it";

import resourcesUderly from "./uderly/resources";
import itResourcesUderly from "./uderly/resources-it";

import resourcesECommerce from "./e-commerce/resources";
import itResourcesECommerce from "./e-commerce/resources-it";

import resourcesAuthentication from "./authentication/resources";
import itResourcesAuthentication from "./authentication/resources-it";

import resourcesQuartarone from "./quartarone/resources";
import itResourcesQuartarone from "./quartarone/resources-it";

import resourcesTriviaPro from "./triviapro/resources";
import itResourcesTriviaPro from "./triviapro/resources-it";

import resourcesRafala from "./rafala/resources";
import itResourcesRafala from "./rafala/resources-it";

import resourcesFoodBond from "./menupro/resources";
import itResourcesFoodBond from "./menupro/resources-it";

import resourcesWoolSafe from "./woolsafe/resources";
import itResourcesWoolSafe from "./woolsafe/resources-it";

import resourcesStay from "./stay/resources";
import itResourcesStay from "./stay/resources-it";

import resourcesVaffa from "./vaffa/resources";
import itResourcesVaffa from "./vaffa/resources-it";

import itResources from './resources-it';

const resources = [];

resources['preloader'] = (
    <div className="animated-preloader">
      <div className="outer">&nbsp;</div>
      <div className="inner">&nbsp;</div>
    </div>);

resources["method-not-implemented"] = "Method not implemented";
resources["property-not-implemented"] = "Property not implemented";

function enResources() {
    resources['or'] = "Or";
    resources['hi'] = "Hi";
    resources['view-user'] = "View user";
    resources['user-profile'] = "User Profile";
    resources['welcome-message'] = "Welcome to " + Settings['project-name'] + " Portal";
    resources['welcome-message-desc'] = "";
    resources['months'] = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    resources['at-time'] = "at";
    resources['days'] = "Days";
    resources['hours'] = "Hours";
    resources['minutes'] = "Minutes";
    resources['seconds'] = "Seconds";
    resources["awesome"] = "Awesome";
    resources["public"] = "Public";
    resources["private"] = "Private";
    resources["language"] = "Language";
    resources["my-account"] = "My Account";
    resources["my-account-desc"] = "";
    resources["hello"] = "Hello";
    resources["insert"] = "Insert";
    resources["update"] = "Update";
    resources["edit"] = "Edit";
    resources["remove"] = "Remove";
    resources["id"] = "Id";
    resources["title"] = "Title";
    resources["value"] = "Value";
    resources["name"] = "Name";
    resources["surname"] = "Surname";
    resources["email"] = "e-Mail";
    resources["phone"] = "Phone";
    resources["mobile-phone"] = "Mobile Phone";
    resources["published"] = "Published";
    resources["your-id-is"] = "Your ID is ";
    resources["item-id-is"] = "This item ID is ";
    resources["item-id"] = "Item ID";
    resources["password"] = "Password";
    resources["created-at"] = "Created At";
    resources["updated-at"] = "Updated At";
    resources["size"] = "Size";
    resources["access-to-portal"] = "Access to " + Settings["project-name"] + " Portal";
    resources["description"] = "Description";
    resources["note"] = "Note";
    resources["internal-notes"] = "Internal Notes";
    resources["company"] = "Company";
    resources["quantity"] = "Quantity";
    resources["price"] = "Price";
    resources["free"] = "Free";
    resources["availability"] = "Availability";
    resources["category"] = "Category";
    resources["date-time"] = "Date & Time";
    resources["time"] = "Time";
    resources["ip-address"] = "IP Address";
    resources["delete"] = "Delete";
    resources["create"] = "Create";
    resources["cancel"] = "Cancel";
    resources["yes"] = "Yes";
    resources["no"] = "No";
    resources["none"] = "None";
    resources["submit"] = "Submit";
    resources["no-items-in-the-list"] = "There are no items to display.";
    resources["no-special-characters-only-comma"] = "Special characters are not allowed, only blank spaces, dashes and commas.";
    resources["from"] = "From";
    resources["to"] = "To";
    resources["save"] = "Save";
    resources["datetime"] = "Date & Time";
    resources["timezone"] = "Timezone";
    resources["document"] = "Document";

    resources["home"] = "Home";
    resources["user"] = "User";
    resources["users"] = "Users";
    resources["role"] = "Role";
    resources["roles"] = "Roles";
    resources["permission"] = "Permission";
    resources["permissions"] = "Permissions";
    resources["admin"] = "Admin";
    resources["assets"] = "Assets";
    resources["logs"] = "Logs";

    resources["store"] = "Store";
    resources["stores"] = "Stores";
    resources["shop"] = "Shop";
    resources["locale"] = "Locale";
    resources["shop-items"] = "Shop Items";
    resources["shop-item"] = "Shop Item";
    // resources["enoteca-item"] = "Enoteca Item";
    // resources["enoteca-items"] = "Enoteca Items";

    resources["saving"] = "Saving...";
    resources["close"] = "Close";
    resources["create-item-first"] = "Create the item before uploading the image.";
    resources["confirm-delete"] = "Are you sure you want to delete this item?";
    resources["confirm-delete-heading"] = "Delete this item";
    resources["attach-files-after-creation"] = "You can attach files after creatin the item.";

    resources["contacts"] = "Contacts";
    resources["contact"] = "Contact";
    resources["contact-name"] = "Contact Name";
    resources["locations"] = "Locations";
    resources["location"] = "Location";
    resources["address"] = "Address";
    resources["post-code"] = "Post Code";
    resources["city"] = "City";
    resources["county"] = "County";
    resources["country"] = "Country";
    
    resources["video-streams"] = "Videos";
    resources["team-members"] = "Team";
    
    resources["tables"] = "Tables";
    resources["social-type"] = "Social Type";
    resources["social-types"] = "Social Types";
    resources["social"] = "Social";
    resources["socials"] = "Socials";
    resources["stream"] = "Stream";
    resources["streams"] = "Streams";
    resources["stream-type"] = "Stream Source";
    resources["stream-types"] = "Stream Sources";
    resources["report"] = "Stand Report";
    resources["reports"] = "Stand Reports";

    resources["assets"] = "Assets";
    resources["asset"] = "Asset";
    resources["version"] = "Version";

    resources["asset-types"] = "Asset Types";
    resources["asset-type"] = "Asset Type";
    resources["type"] = "Type";
    resources["required"] = "Required";
    resources["required-field"] = "Required field";

    resources["week-days-short"] = ["Mon","Tue","Wed","Thu","Fri","Sat","Sun"];
    resources["enable-edit"] = "Enable Edit";
    resources["disable-edit"] = "Disable Edit";
    resources["modules"] = "Modules";
    resources["module"] = "Module";
    resources["too-short"] = "Too short";
    resources["too-long"] = "Too long";
    resources["params"] = "Params";
    resources["invalid-url"] = "Invalid URL";
    resources["max-255-chars"] = "Max 255 characters";
    resources["fill-field"] = "Fill the field";
    resources["hidden-by-user"] = "Hidden by user";
    resources["premium-feature"] = <small>Find out with a premium account.</small>;
    resources["subdomain"] = "Subdomain";
    resources["setup"] = "Setup";
    resources["localization-options"] = "Localization";
    
    resources["shop-not-active"] = "Your store has not been activated yet.";
    resources["shop-disabled"] = "Your store has been disabled.";
    resources["no-role"] = "There are no services associated to this account.";

    resources["recent-touches"] = "Recent Contacts";
    resources["all-touches"] = "Show All";
    resources["newsletter-allowed"] = "Newsletter allowed.";
}

export function loadResources() {
    if(Settings["language"] === "it") {
        itResources(resources);
        itResourcesAuthentication(resources);
        itResourcesFramework(resources);

        if(Settings["project-id"] === ProjectIdsEnum.Uderly) {
            itResourcesECommerce(resources);
            itResourcesUderly(resources);
        }
        if(Settings["project-id"] === ProjectIdsEnum.UderlyPro) {
            itResourcesECommerce(resources);
            itResourcesTriviaPro(resources);
            itResourcesFoodBond(resources);
        }
        if(Settings["project-id"] === ProjectIdsEnum.IqSpace
            || Settings["project-id"] === ProjectIdsEnum.WoolSafe) {
            itResourcesECommerce(resources);
            itResourcesTriviaPro(resources);
        }
        if(Settings["project-id"] === ProjectIdsEnum.WoolSafe) {
            itResourcesWoolSafe(resources);
        }
        if(Settings["project-id"] === ProjectIdsEnum.Stay) {
            itResourcesStay(resources);
        }
        if(Settings["project-id"] === ProjectIdsEnum.Vaffa) {
            itResourcesVaffa(resources);
        }
        if(Settings["project-id"] === ProjectIdsEnum.QrtService) {
            itResourcesECommerce(resources);
            itResourcesQuartarone(resources);
        }
        if(Settings["project-id"] === ProjectIdsEnum.Rafala) {
            itResourcesECommerce(resources);
            itResourcesRafala(resources);
        }
    } else {
        enResources();
        resourcesAuthentication(resources);
        resourcesFramework(resources);

        if(Settings["project-id"] === ProjectIdsEnum.Uderly) {
            resourcesECommerce(resources);
            resourcesUderly(resources);
        }
        if(Settings["project-id"] === ProjectIdsEnum.UderlyPro) {
            resourcesECommerce(resources);
            resourcesTriviaPro(resources);
            resourcesFoodBond(resources);
        }
        if(Settings["project-id"] === ProjectIdsEnum.IqSpace
            || Settings["project-id"] === ProjectIdsEnum.WoolSafe) {
            resourcesECommerce(resources);
            resourcesTriviaPro(resources);
        }
        if(Settings["project-id"] === ProjectIdsEnum.WoolSafe) {
            resourcesWoolSafe(resources);
        }
        if(Settings["project-id"] === ProjectIdsEnum.Stay) {
            resourcesStay(resources);
        }
        if(Settings["project-id"] === ProjectIdsEnum.Vaffa) {
            resourcesVaffa(resources);
        }
        if(Settings["project-id"] === ProjectIdsEnum.QrtService) {
            resourcesECommerce(resources);
            resourcesQuartarone(resources);
        }
        if(Settings["project-id"] === ProjectIdsEnum.Rafala) {
            resourcesECommerce(resources);
            resourcesRafala(resources);
        }
    }
}

// loadResources();

export default resources;